import 'bootstrap/js/dist/alert'
import 'bootstrap/js/dist/button'
import 'bootstrap/js/dist/carousel'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/index'
import 'bootstrap/js/dist/modal'
import 'bootstrap/js/dist/popover'
import 'bootstrap/js/dist/scrollspy'
import 'bootstrap/js/dist/tab'
import 'bootstrap/js/dist/toast'
import 'bootstrap/js/dist/tooltip'
import 'bootstrap/js/dist/util'

// Bootstrap appends its backdrop to <body> with a z-index above any ancestor
// stacking context, so a modal rendered inside a sticky navbar, sidebar or
// similar paints *under* the backdrop and the page goes grey and unclickable.
// Re-parent every modal to <body> as it opens so none can be caught out.
// A modal inside a <form> stays put: moving it would detach its fields.
$(document).on('show.bs.modal', '.modal', function () {
  if (this.parentElement !== document.body && !this.closest('form')) {
    document.body.appendChild(this)
  }
})
